import { Component, OnInit, Input, ComponentFactoryResolver, ViewChild, ElementRef, ComponentFactory, ComponentRef, ViewContainerRef } from '@angular/core';
// tslint:disable-next-line: import-spacing
import { FiltrosFormatoAsistencialEntity, ServicioFormatoAsistencialService, FormatoAsistencialDataEntity,
   NodoEntity, FormatoAsistencialEntity, NotaEntity } from '../../../services/servicio-formato-asistencial.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DatoEntity, TipoObjeto, ValorPreguntaEntity } from '../../../services/servicio-formato-asistencial.service';
import { FilaComponent } from '../componentes/fila/fila.component';
import { AyudasDiagnosticasComponent } from '../componentes/ayudas-diagnosticas/ayudas-diagnosticas.component';

@Component({
  selector: 'app-cuerpo-formato',
  templateUrl: './cuerpo-formato.component.html',
  styleUrls: ['./cuerpo-formato.component.css']
})
export class CuerpoFormatoComponent implements OnInit {

  @Input() public data: FormatoAsistencialEntity;
  @Input() public filtros: FiltrosFormatoAsistencialEntity;
  @ViewChild('mainContainer' , {read : ViewContainerRef}) container: ViewContainerRef;

  nodos: NodoEntity[] = [];
  notas: NotaEntity[] = [];

  constructor( private servicioFormato: ServicioFormatoAsistencialService ,
               private componentFactory: ComponentFactoryResolver) { }

  ngOnInit() {
    if (this.filtros.notas) {
      this.getNotas();
    } else {
      this.getNodos();
    }
  }

  async getNodos() {
    try {
      const response = await this.servicioFormato.getDataFormatoAsistencial(this.filtros.codigoBaseDatos, this.filtros.tta);
      if (response != null) {
        response.subscribe((data: FormatoAsistencialDataEntity) => {          
          this.servicioFormato.valoresPregunta = data.valores;
          this.servicioFormato.nodosCompletos = data.nodos;
          this.servicioFormato.datosCompletos = data.datos;
          this.getNodosPrincipales(data.nodos, data.datos);
        }, (err: HttpErrorResponse) => {
          console.error('Error getNodos()', err);
        });
      }
    } catch (e) {
      console.error('Catch getNodos()', e);
    }
  }

  async getNotas() {
    try {
      const response = await this.servicioFormato.getNotas(this.filtros.codigoBaseDatos, this.filtros.tta);
      if (response != null) {
        response.subscribe((data: NotaEntity[]) => {
          this.notas = data;
          this.getNodos();
        }, (err: HttpErrorResponse) => {
          console.error('Error getNotas()', err);
          this.notas = [];
          this.getNodos();
        });
      }
    } catch (e) {
      console.error('Catch getNotas()', e);
      this.notas = [];
      this.getNodos();
    }
  }

  // Obtener y ordernar nodos

  async getNodosPrincipales (nodos: NodoEntity[], data: DatoEntity[]) {
    let list: NodoEntity[] = [];
    // Se busca los nodos principales
    list = nodos.filter((n: NodoEntity) => {
      const value = n.padreNodo === 0 && n.impresion;
      if (value) {
        n.datos = this.getData(n, data);
        n.notas = this.getNotasNodo(n);
      }
      return value;
    });

    // Se recorren en busqueda de los hijos.
    if (list.length > 0) {
      list.forEach((n: NodoEntity) => {
        n.hijos = this.getNodosHijos(n, nodos, data, true);
      });
    }

    // Se organizan por el campo orden
    list = list.sort((a: NodoEntity, b: NodoEntity) => a.orden - b.orden );

    this.nodos = list;
    this.buildFormato(this.nodos);
    /*if (this.filtros.solicitudServicios) {
      this.buildAyudasDiagnosticas();
    }*/
  }

  getNodosHijos(nodo: NodoEntity, nodos: NodoEntity[], data: DatoEntity[], search: boolean) {
    return nodos.filter((n: NodoEntity) => {
      n.notas = this.getNotasNodo(n);
      const value = n.padreNodo === nodo.id;
      const tipoObjeto = n.codigoTipoObjeto;
      if (value) { n.datos = this.getData(n, data); }
      if (tipoObjeto && search) { n.hijos = this.getNodosHijos(n, nodos, data, false); }
      return value;
    });
  }

  isTipoObjetoHijos(tipoObjeto: number) {
    switch (tipoObjeto) {
      case TipoObjeto.ListaDesplegable:
      case TipoObjeto.Matriz:
      case TipoObjeto.CasillaVerificacion: return true;
      default: return false;
    }
  }

  getData(nodo: NodoEntity, data: DatoEntity[]): DatoEntity[] {
    if (data && data.length > 0) {
      return data.filter((d: DatoEntity) => d.idNodoPrincipal === nodo.id);
    } else {
      return [];
    }
  }

  getNotasNodo(nodo: NodoEntity): NotaEntity[] {
    if (this.notas && this.notas.length > 0) {
      return this.notas.filter((nota: NotaEntity) => {
        return nota.idNodo === nodo.id;
      });
    }
    return [];
  }

  // Construir

  buildFormato(nodos: NodoEntity[]) {
    let row: ComponentRef<FilaComponent> = null;
    let start = false;
    let index = 0;
    nodos.forEach((n: NodoEntity) => {
      const orientacion = n.codigoOrientacion;
      if (orientacion === 1) {
        if (row) {
          row.instance.nodos.push(n);
          if (start) {
            start = false;
            row = null;
          }
        } else {
          row = this.getRow(index);
          row.instance.nodos.push(n);
          start = true;
          index++;
        }
      } else if (orientacion === 2) {
        row = this.getRow(index);
        row.instance.nodos.push(n);
        start = false;
        row = null;
        index++;
      }
    });
  }

  getRow(index: number): ComponentRef<FilaComponent> {
    const factory: ComponentFactory<FilaComponent> = this.componentFactory.resolveComponentFactory(FilaComponent);
    const component: ComponentRef<FilaComponent> = this.container.createComponent(factory);
    component.instance.filtros = this.filtros;
    component.instance.data = this.data;
    component.instance.index = index;
    component.instance.onDelete = () => {
      //this.container.remove(index);
    };
    return component;
  }

  // Ayudas Diagnosticas - Formulación Medica

  buildAyudasDiagnosticas() {
    const factory: ComponentFactory<AyudasDiagnosticasComponent> = this.componentFactory.resolveComponentFactory(AyudasDiagnosticasComponent);
    const component: ComponentRef<AyudasDiagnosticasComponent> = this.container.createComponent(factory);
      component.instance.data = this.data;
      component.instance.filtros = this.filtros;
    return component;
  }

  getAyudaDiagnosticaComponent() {  }



}
